module.exports = __webpack_public_path__ + "img/RICAI_logo.62c1dd24.png";